import React from 'react'
import Divider from '@material-ui/core/Divider'

const XDivider = ({ classes }) => <Divider classes={classes} />

export default XDivider
